<template>
    <div class="mt-1" ref="dropdown">
        <ul class="list-unstyled mb-2">
            <!-- MULTIPLE PRODUCTS → show “N products” + floating dropdown -->
            <li
                v-if="filteredProducts.length > 0"
                style="position: relative;"
            >
                <div
                    class="text-truncate mb-0 text-black-50 d-flex align-items-center"
                    style="font-size: 17px;"
                >
                    PRODUCT:
                    <span
                        class="text-truncate"
                        style="font-weight: 500; color: green; margin-left: 4px;"
                    >
            {{ filteredProducts[0].product_name }} products
          </span>
                    <button
                        @click="toggleProducts"
                        style="
              border: none;
              background: none;
              font-size: 1.25em;
              color: green;
              margin-left: 8px;
              padding: 0;
              line-height: 1;
              cursor: pointer;
            "
                    >
                        {{ showProducts ? '▲' : '▼' }}
                    </button>
                </div>

                <!-- ABSOLUTE dropdown menu -->
                <ul
                    v-show="showProducts"
                    class="list-unstyled"
                    style="
            position: absolute;
            top: 100%;
            left: 0;
            background-color: #FFFFFF;
            border: 1px solid #DDD;
            box-shadow: 0 4px 12px rgba(0,0,0,0.50);
            width: 100%;
            max-height: 300px;
            overflow-y: auto;
            overflow-x: hidden;
            margin-top: 4px;
            z-index: 1;
            padding: 15px;
          "
                >
                    <li
                        v-for="product in filteredProducts"
                        :key="product.product_name"
                        class="mb-3"
                    >
                        <div
                            class="text-truncate mb-1 text-black-50"
                            style="font-size: 15px; font-weight: 700;"
                        >
                            {{ product.product_name }}
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div
                                    class="card rounded-0"
                                    style="height: 2.5rem; background-color: #F8FCFF;"
                                >
                                    <div class="card-body p-1 text-center">
                                        <div class="card-text d-flex">
                                            <div
                                                class="text-black-50 px-2"
                                                style="line-height: 1.75;"
                                            >
                                                PRODUCED:
                                            </div>
                                            <div
                                                class="text-center w-100"
                                                style="color: green; font-size: 1.75em; line-height: 1em;"
                                            >
                                                {{ product.produced }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div
                                    class="card rounded-0"
                                    style="height: 2.5rem; background-color: #F8FCFF;"
                                >
                                    <div class="card-body p-1 text-center">
                                        <div class="card-text d-flex">
                                            <div
                                                class="text-black-50 px-2"
                                                style="line-height: 1.75;"
                                            >
                                                DEFECT:
                                            </div>
                                            <div
                                                class="text-center w-100"
                                                style="color: red; font-size: 1.75em; line-height: 1em;"
                                            >
                                                {{ product.scrapped }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </li>

            <!-- SINGLE PRODUCT → unchanged -->
            <li
                v-else
                v-for="product in filteredProducts"
                :key="product.product_name"
            >
                <div
                    class="text-truncate mb-0 text-black-50"
                    style="font-size: 17px;"
                >
                    PRODUCT:
                    <span
                        class="text-truncate"
                        style="font-weight: 500; color: green;"
                    >
            {{ product.product_name }}
          </span>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div
                            class="card rounded-0"
                            style="height: 2.5rem; background-color: #F8FCFF;"
                        >
                            <div class="card-body p-1 text-center">
                                <div class="card-text d-flex">
                                    <div
                                        class="text-black-50 px-2"
                                        style="line-height: 1.75;"
                                    >
                                        PRODUCED:
                                    </div>
                                    <div
                                        class="text-center w-100"
                                        style="color: green; font-size: 1.75em; line-height: 1em;"
                                    >
                                        {{ product.produced }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div
                            class="card rounded-0"
                            style="height: 2.5rem; background-color: #F8FCFF;"
                        >
                            <div class="card-body p-1 text-center">
                                <div class="card-text d-flex">
                                    <div
                                        class="text-black-50 px-2"
                                        style="line-height: 1.75;"
                                    >
                                        DEFECT:
                                    </div>
                                    <div
                                        class="text-center w-100"
                                        style="color: red; font-size: 1.75em; line-height: 1em;"
                                    >
                                        {{ product.scrapped }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "ProductionSummaryPanel",
    props: {
        produced: Number,
        expected: Number,
        products: {
            type: Array,
        },
        oee: Number
    },
    data() {
        return {
            showProducts: false
        };
    },
    computed: {
        totalOee(){
            return isNaN(this.oee * 100) ? 0 : (this.oee * 100).toFixed(2);
        },
        filteredProducts() {
            return [...this.products].sort((a, b) => {
                const tA = a.produced_at  ? new Date(a.produced_at).getTime() : 0;
                const tB = b.produced_at  ? new Date(b.produced_at).getTime() : 0;
                return tB > tA ? tB : tA;
            });
    }

    },
    methods: {
        toggleProducts() {
            this.showProducts = !this.showProducts;
        },
        handleClickOutside(event) {
            // if dropdown is open and click is outside the component root, close it
            if (this.showProducts && !this.$refs.dropdown.contains(event.target)) {
                this.showProducts = false;
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    }
};
</script>
